import React from 'react';

function BackArrow() {
  /* eslint-disable max-len */
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
      <path d="M18.024 22.391c1.838-1.073 3.294-2.529 4.367-4.367C23.464 16.185 24 14.178 24 12c0-2.177-.537-4.185-1.61-6.023-1.073-1.839-2.529-3.294-4.367-4.367C16.184.536 14.177 0 12 0S7.815.537 5.977 1.61C4.138 2.681 2.682 4.137 1.609 5.976.536 7.815 0 9.823 0 12c0 2.177.537 4.185 1.61 6.024 1.073 1.838 2.53 3.294 4.368 4.367C7.815 23.464 9.823 24 12 24c2.177 0 4.185-.537 6.024-1.61zm-6.743-2.61l-5.656-5.656-1.422-1.421c-.187-.188-.281-.422-.281-.704 0-.28.094-.515.281-.703l1.422-1.422L11.28 4.22c.188-.187.422-.281.704-.281.28 0 .515.093.703.28l1.421 1.423c.198.198.297.432.297.703 0 .271-.099.505-.297.703L11.157 10H19c.27 0 .505.1.703.297.198.198.297.432.297.703v2c0 .271-.099.506-.297.704-.198.197-.432.297-.703.297h-7.843l2.952 2.952c.188.188.282.422.282.704 0 .28-.094.515-.282.703l-1.421 1.422c-.188.187-.422.28-.704.28-.28 0-.515-.093-.703-.28z" />
    </svg>
  );
  /* eslint-enable */
}

export default BackArrow;



// WEBPACK FOOTER //
// ./src/common/icons/BackArrow.js